<script>

    $: fullWidth = 0;
    $: fullHeight = 175;

    let margin = {top: 20, right: 15, bottom: 10, left: 15};
    $: width = fullWidth - margin.left - margin.right;
    $: height = fullHeight - margin.top - margin.bottom;

    let r = 20;
    let circleStroke = 7;

    let i = 1;
    let exampleData = [
        {
            name: 'Dalston Junction',
            cost: '£1,880',
            color: "#ef7b10",
        },
        {
            name: 'Wood Green',
            cost: '£1,300',
            color: '#0019A8'
        },
        {
            name: 'Pimlico',
            cost: '£2,383',
            color: '#039BE5'
        },
        {
            name: 'Stockwell',
            cost: '£1,590',
            color: '#000000'
        },
        {
            name: 'South Kensington',
            cost: '£2,425',
            color: '#007D32'
        }
    ]


    let selectedExample = exampleData[0]

    setInterval(() => {
        selectedExample = exampleData[i]
        if (i + 1 == exampleData.length) {
            i = 0
        } else {
            i += 1
        }
        
    }, 1500)

</script>

<style>

    .cost-label {
        font-size: 32px;
    }
    .station-label {
        font-size: 32px;
    }

</style>

<div class='intro-graphic-con' bind:clientWidth={fullWidth}>

    <svg
        width={fullWidth}
        height={fullHeight}
    >
        <g
            transform={`translate(${margin.left}, ${margin.top})`}
        >

            <line
                x1={0}
                x2={width}
                y1={height / 2}
                y2={height / 2}
                stroke-width="10px"
                stroke={selectedExample.color}
            />

            <circle
                cx={width / 2}
                cy={height / 2}
                fill="white"
                {r}
                stroke="black"
                stroke-width={circleStroke}

            />

            <text
                x={width / 2}
                y={height / 2 - (r * 2) - circleStroke}
                dominant-baseline='central'
                text-anchor='middle'
                class='station-label'
            >
                {selectedExample.name}
            </text>
            <text
                x={width / 2}
                y={height / 2 + (r * 2) + circleStroke}
                dominant-baseline='central'
                text-anchor='middle'
                class='cost-label'
            >
                {selectedExample.cost}
            </text>

        </g>
    </svg>

</div>